var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndeed11(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "73px",
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 178,
    transform: "translate(-106.000000, -139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(106.231000, 139.028000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.863,71.726 L35.863,71.726 C16.056,71.726 -7.10542736e-15,55.67 -7.10542736e-15,35.863 C-7.10542736e-15,16.056 16.056,1.42108547e-14 35.863,1.42108547e-14 C55.67,1.42108547e-14 71.727,16.056 71.727,35.863 C71.727,55.67 55.67,71.726 35.863,71.726",
    id: "Fill-24",
    fill: "#0079AB"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#FFFFFE",
    points: "19.601 51.847 27.023 51.847 27.023 27.868 19.601 27.868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.277,24.729 C25.701,24.729 27.666,22.746 27.666,20.303 C27.666,17.86 25.701,15.879 23.277,15.879 C20.852,15.879 18.888,17.86 18.888,20.303 C18.888,22.746 20.852,24.729 23.277,24.729",
    id: "Fill-26",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.888,39.26 C38.888,35.889 40.44,33.88 43.411,33.88 C46.14,33.88 47.451,35.808 47.451,39.26 C47.451,42.713 47.451,51.847 47.451,51.847 L54.839,51.847 C54.839,51.847 54.839,43.088 54.839,36.665 C54.839,30.242 51.198,27.136 46.114,27.136 C41.028,27.136 38.888,31.098 38.888,31.098 L38.888,27.868 L31.768,27.868 L31.768,51.847 L38.888,51.847 C38.888,51.847 38.888,42.954 38.888,39.26",
    id: "Fill-27",
    fill: "#FFFFFE"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndeed11);
export default __webpack_public_path__ + "static/media/indeed11.4bbf4edab01f3991b143ea9bfd7a804c.svg";
export { ForwardRef as ReactComponent };